fd-flex fd-content-1200 fd-kypm<template>
    <div id="app">
        <div class="fd-main" :class="{'fd-sy':sfSy}">
            <div class="fd-container">
                <div class="fd-top noprint">
                    <div class="fd-content-1200">
                        <div class="fd-top-cz ">
                            <aty-button type="primary" class="fd-no-space" @click="gotoYw">ENGLISH</aty-button>
                            <span class="fd-text " @click="gotoYdy">返回引导页</span>
                            <div class="fd-sy-search">
                                <aty-input
                                    v-model="search"
                                    @keyup.enter="gotoSearch"
                                    placeholder="请输入您要搜索的内容"></aty-input>
                                <span class="fd-search-icon" @click.stop="gotoSearch"></span>
                            </div>

                        </div>
                        <div :class="['fd-logo',{'module':activeCode!=='index'||!sfSy}]" >
                            <p class="fd-logo-text">中国海事审判</p>
                            <p class="fd-logo-sub-text">CHINA&nbsp;MARITIME&nbsp;TRIAL</p>
                        </div>
                    </div>
                    <div class="fd-nav-box">
                        <ul class="fd-nav-content">
                            <li v-for="item in navList"
                                @click="changeActive(item)"
                                :class="['fd-nav-item',{'active':activeCode===item.code}]"
                                :key="item.code">{{ item.name }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div :class="{'fd-module-page':activeCode!=='index'||!sfSy}">
                    <router-view class="fd-second-main"/>
                    <fd-footer class="noprint"></fd-footer>
                </div>
            </div>
            <div v-if="sfSy && showWin"
                 id="js-float-window"
                 class="fd-float-window"
                 :style="{'top': `${top}px`, 'left': `${left}px`}"
                 @mouseenter="enterWin()"
                 @mouseleave="initWin()">
                <span class="fd-win-destroy" @click="showWin = false">关闭</span>
                <img src="~@/images/piao-wd.jpg" alt="" @click="clickWin()">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            // 头部导航
            navList: [
                {
                    name: '首页',
                    code: 'index',
                    path: '/index'
                }, {
                    name: '新闻资讯',
                    code: 'xwzx',
                    path: '/xwzx'
                }, {
                    name: '诉讼服务',
                    code: 'ssfw',
                    path: '/ssfw'
                }, {
                    name: '法律资源',
                    code: 'flzy',
                    path: '/flzy'
                }, {
                    name: '审判研究',
                    code: 'hsal',
                    path: '/hsal'
                }, {
                    name: '发展历程',
                    code: 'fyjs',
                    path: '/fyjs'
                }, {
                    name: '审执数据',
                    code: 'szsj',
                    path: '/szsj'
                }
            ],
            search:'',
            activeCode: 'index',
            sfSy: false,
            top: 0,
            left: 0,
            winInterval: null,
            showWin: true
        };
    },
    created() {
        const activePath = this.$route.path;
        const activeFlag = this.$route.query.active || this.$route.meta.active;
        this.activeCode = activeFlag || activePath.split('/')[1];
        this.sfSy = !this.$route.meta.active && !this.$route.query.active && this.activeCode === 'index';
    },
    mounted() {
        document.documentElement.scrollLeft = (document.getElementById('app').offsetWidth - 1200) / 2;
        this.initWin();
    },
    watch: {
        '$route.path': {
            handler(val) {
                const activeFlag = this.$route.query.active || this.$route.meta.active;
                this.activeCode = activeFlag || val.split('/')[1];
                this.sfSy = !this.$route.meta.active && !this.$route.query.active && this.activeCode === 'index';
                this.$nextTick(() => {
                    document.getElementById('app').scrollTop = 0;
                    document.documentElement.scrollLeft = (document.getElementById('app').offsetWidth - 1200) / 2 - 50;
                });
            },
            immediate: true
        }
    },
    methods: {
        changeActive(item) {
            this.activeCode = item.code;
            if (item.path && item.path !== this.$route.path) {
                this.$router.push({path: item.path});
            }
        },
        gotoSearch() {

            if (this.search && this.search.trim() !== '') {
                this.$router.push({path:'/search', query:{search:this.search}});
            }
        },
        gotoYw() {
            window.open(window.serverConfig.ywdz);
        },
        gotoYdy() {
            window.location.href = window.serverConfig.ydy;
        },
        initWin() {
            this.winInterval = window.setInterval(() => {
                if (this.top < 0) {
                    this.toBottom = true;
                }
                if (this.left < 0) {
                    this.toRight = true;
                }
                if (this.top > document.body.clientHeight - $('#js-float-window').height()) {
                    this.toBottom = false;
                }

                if (this.left > document.body.clientWidth - $('#js-float-window').width()) {
                    this.toRight = false;
                }
                this.toBottom ? this.top ++ : this.top --;
                this.toRight ? this.left ++ : this.left --;
            }, 15);
        },
        enterWin() {
            window.clearInterval(this.winInterval);
            this.winInterval = null;
        },
        clickWin() {
         //   window.open('https://cmt.court.gov.cn/hssp-zw/#/xwzxDetail?active=xwzx&bh=a187d883661df552e80762933edb31ce&fileType=23');
            window.open('https://cmt.court.gov.cn/hssp-zw/#/zt/hssp40');

        }
    },
    beforeDestroy() {
        this.enterWin();
    }
};
</script>

<style lang="less">
@import "./css/index.less";
</style>
